import { defineStore } from "pinia";

export interface ICountry {
  label: string;
  value: string;
  phone_prefix: string;
  data?: Data;
}

export interface Data {
  fields: Fields;
}

export interface Fields {
  state: State;
}

export interface State {
  label: string;
  type: Type;
  required: boolean;
}

export enum Type {
  Text = "text",
}

export interface IPrefix {
  label: string;
  value: string;
  iso: string;
}

export const useCountriesStore = defineStore("Countries", () => {
  const countries = ref<ICountry[]>();
  const loading = ref(false);

  const prefixes = computed<IPrefix[]>(
    () =>
      countries.value?.map((country) => ({
        label: "+" + country.phone_prefix,
        value: "+" + country.phone_prefix,
        iso: country.value,
      })) || []
  );

  const fetchCountries = () => {
    loading.value = true;
    return homeFetch<ICountry[]>("countries")
      .then((r) => {
        countries.value = r.data;
      })
      .finally(() => {
        loading.value = false;
      });
  };

  // Initialize countries data when the store is first used
  fetchCountries();

  return {
    countries,
    loading,
    prefixes,
    fetchCountries,
  };
});
